import {startTypeShuffle, toggleModalSketch, utils} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateArchiveInit() {

	gsapContext.add(() => {

		const projects               = document.querySelectorAll('.project');
		const projectsDownloads      = document.querySelector('.projects-downloads');
		const projectsDownloadsItems = projectsDownloads.querySelectorAll('.project-download');

		var swiper = new Swiper(".projects-archive .swiper", {
			effect:          "coverflow",
			loop:            true,
			grabCursor:      true,
			centeredSlides:  true,
			slidesPerView:   'auto',
			speed:           600,
			coverflowEffect: {
				rotate:       5,
				stretch:      -50,
				depth:        100,
				modifier:     1,
				slideShadows: true,
			},/*
			pagination: {
				el: ".swiper-pagination",
			},*/
			on:              {
				slideChange: function () {
					utils.slideUp(projectsDownloads);

					setTimeout(function () {
						projectsDownloads.classList.remove('projects-downloads--visible');

						ScrollTrigger.getAll().forEach(t => t.refresh());
					}, 500);
				},
			}
		});

		projects.forEach((el) => {
			el.addEventListener('click', function () {

				if (!el.parentNode.classList.contains('swiper-slide-active'))
				{
					return false;
				}

				const id = el.dataset.id;

				projectsDownloadsItems.forEach((el) => {
					el.classList.remove('active');
				});

				document.querySelector('.project-download[data-id="' + id + '"]').classList.add('active');

				projectsDownloads.classList.add('projects-downloads--visible');

				utils.slideDown(projectsDownloads);

				setTimeout(function () {
					ScrollTrigger.getAll().forEach(t => t.refresh());
				}, 500);
			});
		});

		let projectsDownloadsHeight = projectsDownloads.offsetHeight;

		projectsDownloads.setAttribute("data-height", projectsDownloadsHeight);

	});

}